import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApi from "../utils/useApi";

// Filial em modo Ouran usa o catalogo global de categorias em vez das
// colecoes ERP congeladas - mesma fonte que EscopoDoEvento.js ja usa
// (getOuranCatalogPilot), so' que aqui pro filtro "Categoria" da tela de
// Receita. category_source: "ouran" acompanha os ids selecionados pra o
// backend saber como interpreta-los (ver revenue_app/views.py).
export default function useCollections() {
  const { getCollections, getOuranCatalogPilot } = useApi();
  const { user } = useAuth();

  const pilot = useQuery({
    queryKey: [
      "ouranCatalogPilot",
      user?.user_id ?? null,
      user?.active_branch_id ?? null,
    ],
    queryFn: () => getOuranCatalogPilot().catch(() => null),
  });
  const modoOuran = pilot.data?.category_mode === "ouran";

  const { data, isLoading } = useQuery({
    queryKey: [
      "collections",
      user?.user_id ?? null,
      user?.active_branch_id ?? null,
    ],
    queryFn: () => getCollections(),
    enabled: !pilot.isLoading && !modoOuran,
    select: (collectionsData) => {
      const allCollectionValues = collectionsData?.data?.map(
        (collection) => collection?.value
      );

      const options = [
        { value: "all", label: "Todos" },
        ...(collectionsData.data || []).map((collection) => ({
          value: collection?.value,
          label: collection?.label,
        })),
      ];

      const legacyIdDaColecao = Object.fromEntries(
        (collectionsData.data || []).map((collection) => [
          collection?.value,
          collection?.col_id,
        ])
      );

      return {
        options,
        allValues: allCollectionValues,
        legacyIdDaColecao,
      };
    },
  });

  if (modoOuran) {
    const categorias = pilot.data?.categories || [];
    const options = [
      { value: "all", label: "Todos" },
      ...categorias.map((categoria) => ({
        value: categoria.id,
        label: categoria.name,
      })),
    ];
    return {
      data: options,
      isLoading: pilot.isLoading,
      modoOuran: true,
      legacyIdDaColecao: {},
    };
  }

  return {
    data: data?.options,
    isLoading: pilot.isLoading || isLoading,
    modoOuran: false,
    legacyIdDaColecao: data?.legacyIdDaColecao ?? {},
  };
}
